export const STATUS_MESSAGE = {
  OK: 'descSuccess',
  ERROR: 'keyCallMeError',
  ALREADY_REGISTERED: 'keyAlreadyRegistered',
  INVALID_PHONE: 'keyInvalidPhone',
  CLOSED: 'keyClosed',
  DUPLICATE_PHONE_NUMBER: 'keyDuplicatePhoneNumber'
};
